import script from "./SimpleModalButton.vue?vue&type=script&lang=js"
export * from "./SimpleModalButton.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__